import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

function PublicPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    if (code) {
      navigate(`/?code=${code}`, { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [navigate, searchParams]);

  return (
    <div className="page">
      <div className="loading">Redirecting...</div>
    </div>
  );
}

export default PublicPage;
